<template>
<div class="w-screen h-screen">
  <!-- <div id="nav">
    <router-link to="/">Configurator</router-link> |
    <router-link to="/shop/order-history">Order history</router-link>
  </div> -->
  <!-- Header -->
  <div class="text-right pr-4 md:pr-16 text-secondary w-full flex justify-between items-center navbar">
    <img class="header-logo clickable" :src="logoUrl" @click="navigateModel">
    <div v-if="!getSteps.hide" class="md:hidden text-right">
      <b>Step {{ getSteps.step }} of {{ getSteps.totalSteps }}</b>
    </div>
    <a-steps class="hidden md:inline-block">
      <a-step v-for="step in steps" :key="step.title" icon="X" :title="step.step + '. ' + step.title" :class="{
        'active': getSteps.step === step.step,
        'cursor-pointer': getSteps.step >= step.step,
        'cursor-not-allowed': getSteps.step < step.step,
        }" @click="navigate(step.step)"/>
      <!-- TODO: disable future steps? -->
    </a-steps>
    <Switcher />  
  </div>
  <div ref="routerView" id="routerView" class="w-full content">
    <router-view class="margin-bottom" />
  </div>
  <!-- Footer -->
  <div class="text-right md:pr-16 pr-3 text-secondary w-full flex items-center justify-between footer">
    <div class="content-text">
      <h3 v-if="getFooterContent.content" v-html="getFooterContent.content.text"></h3>
    </div>
    <div class="text-center">
      <a-button v-if="getFooterContent.back" type="text" size="large" :disabled="getFooterContent.back.disabled" @click="handleClickBack" class="back-button button-text md:mr-6">{{ getFooterContent.back.text }}</a-button>
      <a-button v-if="getFooterContent.next" type="primary" shape="round" size="large" :disabled="getFooterContent.next.disabled" @click="handleClickNext" class="next-button button-text">{{ getFooterContent.next.text }}</a-button>
    </div>
  </div>
</div>
</template>

<style lang="scss">
#app {
  font-family: 'IBM Plex Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
  .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
    // display: none !important;
    content: none !important;
  }
  .ant-steps {
  }

  .ant-steps-item > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    color: theme('colors.secondary.DEFAULT');
    font-weight: 400;
  }

  .ant-steps-item.active > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    color: theme('colors.black');
    font-weight: 600;
  }

  // this sets icon width to 0. If you want icons, remove this.
  .ant-steps:not(.ant-steps-vertical) .ant-steps-item-custom .ant-steps-item-icon {
    width: 0;
    margin-right: 0;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.navbar {
  height: 50px;
  box-shadow: 0px 0px 33px #E8E8E8;
  opacity: 1;
  position: relative;

  @media only screen and (min-width: 768px) { 
    height: 80px;
  }

  .ant-steps-horizontal.ant-steps-label-horizontal {
    @media only screen and (max-width: 480px) {
      display: none;
    }
  }
}

.footer {
  height: 60px;
  box-shadow: 0px 0px 33px #E8E8E8;
  opacity: 1;
  background: #fff;

  position: fixed;
  bottom: 0;

  @media only screen and (min-width: 640px) {
    height: 80px;
  }

  .back-button {
    color: theme('colors.secondary.DEFAULT');
    height: 40px;
    font-size: 16px;
    border-radius: 40px;
    padding-right: 20px;
    padding-left: 20px;
    @media only screen and (min-width: 640px) {
      padding-right: 50px;
      padding-left: 50px;
    }
  }

  .next-button {
    padding-right: 20px;
    padding-left: 20px;
    @media only screen and (min-width: 640px) {
      padding-right: 50px;
      padding-left: 50px;
    }
  }

  .content-text {
    padding-left: 10px;
    @media only screen and (min-width: 640px) {
      padding-left: 40px;
    }

    h3 {
      font-size: 16px;
      font-weight: bold;
      padding-left: 10px;
      @media only screen and (min-width: 640px) {
        font-size: 22px;
        font-weight: normal;
      }
    }
  }
}

.content {
  // height: calc(100vh - 180px - 81px); // TODO: remove 81px once Configurator | Order history is removed from top
  height: calc(100vh - 110px);
  overflow-y: scroll;
  @media only screen and (min-width: 640px) {
    height: calc(100vh - 160px);
  }
}

.header-logo {
  max-height: 40px;
  padding-left: 32px;
  @media only screen and (min-width: 640px) {
    max-height: 50px;
  }
}

// #routerView {
//   max-width: 1280px;
//   width: 100%;
//   margin: 0 auto;
//   overflow: visible;
// }

.margin-bottom {
  padding-bottom: 8rem
}
</style>

<script lang="ts">
import { Options, Vue }    from 'vue-class-component';
import { mapGetters, mapActions } from 'vuex';
import { config } from '@/config';
import { salesqueze } from './libs/salesqueze-sdk-browser';
import Switcher from './components/shared/switcher.vue'

@Options({
  components: {
    Switcher
  },
  computed: mapGetters(['getFooterContent', 'getSteps', 'getCurrentItem', 'getPartnerData', 'getIsCartPriceable', 'getProducts', 'getLang']),
  methods: mapActions(['setFooterContent', 'setTotalSteps', 'setCurrentStep', 'unsetCurrentItem', 'setPartnerData', 'updateCartProducts', 'setForm', 'setLang']),
  name: 'App',
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || 'Vez Sedeži'
        let queryChange = false;
        let query = Object.assign({}, to.query);

        if (to.query && to.query.partnerKey) {
          this.$store.state.partnerKey = to.query.partnerKey as string;
          sessionStorage.setItem('partnerKey', this.$store.state.partnerKey)
        } else if (sessionStorage.getItem('partnerKey')) {
          this.$store.state.partnerKey = sessionStorage.getItem('partnerKey');
        }
        if (to.query && to.query.lang) {
          if (to.query.lang !== this.getLang) {
            this.setLang(to.query.lang);
            this.$i18n.locale = to.query.lang;
          }
          delete query.lang;
          queryChange = true;
        }
        if ((!from || (from.query && !from.query.documentId && !from.query.edit_token)) && to.query && to.query.documentId && to.query.edit_token) {
          this.handleEditData(to.query.documentId as string, to.query.edit_token as string);
        }
        if (queryChange) {
          this.$router.replace({
            path: to.path,
            query: query,
          });
        }
      }
    }
  }
})
export default class Dev extends Vue {
  getFooterContent!: any;

  logoUrl = `https://salesqueze-production-fs.s3.eu-central-1.amazonaws.com/${config.clientKey}/assets/logo.png`
  declare setPartnerData: (data: any) => void;
  declare getPartnerData: any;
  declare getIsCartPriceable: boolean;
  declare getProducts: any[];
  declare updateCartProducts: (data: any) => void;
  declare setForm: (data: any) => void;
  declare getLang: string;

  async mounted(): Promise<void> {
    (this as any).setTotalSteps(this.steps.length);
    await this.handlePartnerData();
    // await this.handleEditData();
  }

  async handlePartnerData(): Promise<void> {
    
    if (this.$store.state.partnerKey) {
      const partnerInfo = await salesqueze.getPartnerInfo(this.$store.state.partnerKey);
      this.setPartnerData(partnerInfo.data);
    }
  }

  async handleEditData(documentId: string, editToken: string): Promise<void> {
    this.$store.state.loadingEdit = true;
    try {
      const order = await salesqueze.getOrder(documentId, editToken);
      this.updateCartProducts(order?.data?.cpq?.cart?.products.map((val: any) => {
        val.key = val.catalogKey;
        val.configurableAddons = val.configurableAddons.map((addon: any) => {
          addon.products = addon.products.map((prod: any) => {
            prod.key = prod.catalogKey;
            return prod;
          });
          return addon;
        })
        return val;
      }));
      this.setForm(order?.data?.form || {});
    } catch(e) {
      // do nothing
    } finally {
      this.$store.state.loadingEdit = false;
    }

  }

  async handleClickNext(): Promise<void> {
    if (this.getFooterContent.next.to) {
      this.$router.push(this.getFooterContent.next.to)
    } else if (this.getFooterContent.next.action) {
      await this.getFooterContent.next.action();
    }
  }

  async handleClickBack(): Promise<void> {
    if (this.getFooterContent.back.to) {
      this.$router.push(this.getFooterContent.back.to)
    } else if (this.getFooterContent.back.action) {
      await this.getFooterContent.back.action();
    } else if (!(this as any).getCurrentItem.key) {
      this.$router.push(this.steps[0].to);
    } else if ((this as any).getSteps.step) {
      this.$router.push(this.steps[(this as any).getSteps.step - 2].to);
    } else {
      this.$router.back();
    }
  }

  navigate(step: string): void {
    const stepEntry: any = this.steps.find((elem: any) => elem.step === step)
    if (stepEntry && step < (this as any).getSteps.step){
      this.$router.push(stepEntry.to)
    }
  }

  navigateModel(): void {
    (this as any).unsetCurrentItem();
    this.$router.push('/shop/model');
  }

  get steps(): any[] {
    return [
    {
      title: this.$t('nav.model'),
      step: 1,
      to: '/shop/model'
    },
    {
      title: this.$t('nav.details'),
      step: 2,
      to: '/shop/details'
    },
    {
      title: this.$t('nav.summary'),
      step: 3,
      to: '/shop/summary'
    },
    {
      title: this.$t('nav.preview'),
      step: 4,
      to: '/shop/preview'
    },
  ]
  }
}
</script>
